export function getAdvertiseFormData(state) {
  return state.advertise.formData;
}
export function getAdvertiseIncomingLeads(state) {
  return state.advertise.incomingLeads;
}
export function getAdvertiseRecommendations(state) {
  return state.advertise.recommendations;
}
export function getAdvertiseCategoryList(state) {
  return state.advertise.categoryList;
}
export function getAdvertiseWhereList(state) {
  return state.advertise.whereList;
}
export const mapCategoryKeyToId = categoryKey => {
  return categoryIds[categoryKey];
};
const categoryIds = {
  electricians: 8,
  painters: 12,
  plumbers: 11,
  carpenters: 19,
  plastering: 31,
  garden_maintenance: 78,
  tilers: 35,
  bricklayers: 51,
  structural_engineer: 104,
  handyman: 55,
  roofing: 13,
  concretors: 22,
  air_conditioning: 48,
  demolition: 42,
  arborists: 47,
  cabinet_makers: 4,
  excavation: 76,
  renderer: 46,
  pest_control: 30,
  fences: 25,
  furniture_removal: 91,
  gas_fitters: 1142,
  carpet_layers: 6,
  lawn_mowing: 95,
  window_cleaners: 85,
  timber_flooring: 15,
  drafters: 41,
  carpet_cleaning: 23,
  decking: 58,
  paver: 26,
  floor_sanding: 88,
  security_screens_doors: 67,
  rubbish_remover: 34
};
